import React, { memo } from 'react'
import { Tooltip, Upload } from 'antd'
import validateFile from '../../helpers/validateFile'
import Attach from '../Icons/attach.svg'
import Delete from '../Icons/delete.svg'
import { useTranslation } from "react-i18next"
import "./style.css"

const CustomUpload = memo(({
		multiple = false,
		maxCount = 5,
		disabled = false,
		isExcel = false,
		download = false,
		onDownload = null,
		defaultFileList = [],
		onChange = null,
		canEdit
	}) => {
		const {t} = useTranslation(['valid', 'action'])
		const filesFormat = t('valid:filesFormat') + ` ".jpg", "jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".tif", ".tiff" ` + t('valid:fileSizeMB', {size: 15})
		const fileFormat = t('valid:fileFormat') + ` ".xlsx" ` + t('valid:fileSizeMB', {size: 15})

		return (
			<Upload
				beforeUpload={ file => validateFile(file, isExcel) }
				className="upload-user-custom"
				customRequest={ null }
				defaultFileList={ defaultFileList }
				disabled={ disabled }
				iconRender={() => null}
				itemRender={(originNode, file, fileList, actions) => {
					return (
						<div className="custom-file">
							<Tooltip
								placement="left"
								title={file.name ?? (file.fileName + file.fileExtension)}
							>
								<span
									style={{ cursor: (download && file.id) ? "pointer" : null }}
									onClick={() => file.id && onDownload(file)}
								>
									{file.name ?? (file.fileName + file.fileExtension)}
								</span>
							</Tooltip>
							{
								(!download || canEdit) &&
									(
										(
											<img alt=""
												src={ Delete }
												style={{cursor: "pointer"}}
												onClick={() => actions.remove()}
											/>
										)
									)
							}
						</div>
					)
				}}
				listType="text"
				maxCount={ maxCount }
				multiple={ multiple }
				onChange={ onChange ?? false }
			>
				{
					((!download || canEdit) &&
						(
							<Tooltip title={isExcel ? fileFormat : filesFormat}>
								<div className="add-file">
									<img alt=""
										src={ Attach }
									/>
									<span>
										{t('action:addFile', {count: multiple ? 3 : 1})}
									</span>
								</div>
							</Tooltip>
						))
				}
			</Upload>
		)
	}
)

export default CustomUpload